<template>
  <div class="page-wrapper">
      <!--begin::Content-->
        <div class="left"> 
            <div class="logo">
                 <router-link class="text-capitalize" :to="{ name: 'signin' }">
                    <img src="/media/logos/logo-dark-new.png" alt="Logo">
                </router-link>
            </div>
            <div class="reset_head">
              <h1 class="font-size-h1" style="font-weight:bold;color:#000">Reset Password</h1>
            </div>
            <div class="form">
               <b-form class="form" @submit.stop.prevent="onSubmit">
                    <div role="alert" v-bind:class="{ show: errors.length }" class="alert fade alert-danger d-flex align-items-center pl-3" style="height:36px;margin-bottom:10px;">
                        <span>{{ $store.state.resetPasswordError }}</span>
                    </div>
                    <div role="alert" v-if="success" :class="{ 'show': success }" class="alert fade alert-success d-flex align-items-center pl-3" style="height:36px;margin-bottom:10px;">
                        <span>{{ this.successMsg }}</span>
                    </div>
                    <div class="input-group">
                        <label for="">Password</label>
                        <input type="text" placeholder="Type your Password Here" v-if="showPassword1" v-model="$v.form.password.$model">
                        <input v-else type="password" placeholder="Type your Password Here"  v-model="$v.form.password.$model">
                        <a @click="toggleShow1"><i class="fas" :class="{ 'fa-eye-slash': showPassword1, 'fa-eye': !showPassword1 }"></i></a>
                        <div v-if="submitted && $v.form.password.$error" class="invalid-feedback-two">
                            <p v-if="!$v.form.password.required" style="color:red;">Password is required</p>
                            <p v-else-if="!$v.form.password.minLength" style="color:red;">Password must be atleast 8 digits</p>
                            <p v-else-if="form.password && !$v.form.password.valid" style="color:red;">Password must  contains atleast One Uppercase, One Lowercase, One Number and One Special Character</p>
                            <p v-else-if="form.password && !$v.form.password.maxLength" style="color:red;">Password should not greater 16 characters</p>
                        </div>
                    </div>
                    <div class="input-group">
                        <label for="">Retype Password</label>
                        <input type="text" placeholder="Type your New Password" v-if="showPassword2" v-model="$v.form.retype_password.$model">
                        <input v-else type="password" placeholder="Type your New Password"  v-model="$v.form.retype_password.$model">
                        <a @click="toggleShow2"><i class="fas" :class="{ 'fa-eye-slash': showPassword2, 'fa-eye': !showPassword2 }"></i></a>
                        <!-- <div v-if="submitted && $v.form.retype_password.$error" class="invalid-feedback-two">
                             <p v-if="!$v.form.retype_password.required" style="color:red;">Confirm Password is required</p>
                             <p v-else-if="!$v.form.retype_password.minLength" style="color:red;">Confirm Password must be atleast 8 digits</p>
                             <p v-else-if="!$v.form.retype_password.sameAsPassword" style="color:red;">Confirm Password Not Matched with New Password</p>
                        </div> -->
                        <div v-if="submitted && $v.form.retype_password.$error" class="invalid-feedback-two">
                            <p v-if="!$v.form.retype_password.required" style="color:red;">Confirm Password is required</p>
                            <p v-else-if="!$v.form.retype_password.sameAsPassword" style="color:red;">Confirm Password Not Matched with New Password</p>
                        </div>
                    </div>
                    <div class="skip">
                        <button ref="kt_reset_password_submit" class="btn btn-dark form-control">Save</button>
                    </div>
                    <div class="login_switch">
                        <span>Back To</span>
                        <router-link class="font-weight-bold font-size-3 ml-2" :to="{ name: 'signin' }">
                            Log In
                        </router-link>
                        <!-- <a href="">Log In</a> -->
                    </div>
                </b-form>
            </div>
        </div>
        <div class="right">
              <div class="right-inner">
              <div class="icon1">
                  <img src="media/images/icon 2.png" alt="">
              </div>
              <div class="title">
                  <h2>
                      Connecting <br> leading<br> affiliates to<br> global brands
                  </h2>
              </div>
              <div class="list">
                  <ul>
                      <li><img src="media/images/star 1.png" alt=""> Fast Payments</li>
                      <li><img src="media/images/star 1.png" alt="">Fast Communication</li>
                      <li><img src="media/images/star 1.png" alt="">Transparency</li>
                      <li><img src="media/images/star 1.png" alt="">Higher Payouts</li>
                  </ul>
                  <img src="media/images/icon 2.png" alt="">
              </div>
              <div class="icon2">
                  <img src="media/images/icon 2.png" alt="">
              </div>
             <footer>
                  <p>All rights are reserved</p>
                  <ul>
                      <li>
                          <a href="https://www.cpxaffiliate.com/en/terms">Terms of Service</a>
                      </li>
                  </ul>
              </footer>
          </div>
          </div>
      </div>
  </div>
</template>
<style lang="scss">
@import "@/assets/sass/pages/reset_password/reset_password.scss";
</style>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>
<script>


import { mapState } from "vuex";
import { RESET_PASSWORD } from "@/core/services/store/auth.module";

import { validationMixin } from "vuelidate";
import { minLength, required,sameAs,maxLength } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "reset_password",
  data() {
    return {
      showPassword1: false,
      showPassword2: false,
      password: null,
      retype_password: null,
      submitted :false,
      user_id : '',
      successMsg : null,
      success :false,
      // Remove this dummy login info
      form: {
        password: "",
        retype_password: "",
      },
    };
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(16),
        valid: function(value) {
          const containsUppercase = /[A-Z]/.test(value)
          const containsLowercase = /[a-z]/.test(value)
          const containsNumber = /[0-9]/.test(value)
          const containsSpecial = /[#?!@$%^&*-]/.test(value)
          return containsUppercase && containsLowercase && containsNumber && containsSpecial
        },
      },
      retype_password: {
        required,
        sameAsPassword:sameAs('password'),
      },
    },
  },
  methods: {
    toggleShow1() {
      this.showPassword1 = !this.showPassword1;
    },
    toggleShow2() {
      this.showPassword2 = !this.showPassword2;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        password: null,
        retype_password : null, 
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.submitted = true
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return false;
      }
      const id = this.user_id;
      const password = this.$v.form.password.$model;
    
        // clear existing errors
      // set spinner to submit button
      const submitButton = this.$refs["kt_reset_password_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      // dummy delay

      // send login request
      this.$store
        .dispatch(RESET_PASSWORD, {
          id,
          password,
        })
        // go to which page after successfully login
        .then((resp) => {
            this.success = true;
            this.successMsg = resp.message;
            this.resetForm();
            setTimeout(()=>{
                this.$router.push({
                    name: "signin",
                })
            },3000);
        });
      // .catch((data) => {
      //       this.error = true;
      //       this.errorsMsg = data.message;
      // });

      submitButton.classList.remove(
        "spinner",
        "spinner-light",
        "spinner-right"
      );
    },
  },
  mounted() {
    // if (localStorage.getItem("id_token")) {
    //   this.$router.push("dashboard");
    // },
    this.user_id = this.$route.query.id;
    // localStorage.clear();
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
      successs: state => state.auth.successs
    }),
    buttonLabel() {
      return (this.showPassword1) ? "Hide" : "Show";
      return (this.showPassword2) ? "Hide" : "Show";
    },
  },
};
</script>
<style scoped>
.form-control.form-control-solid {
  background-color: #fff2f2;
  border-color: #f3fcfe;
  border-radius: 5px;
  font-size: 16px;
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #37a4cb !important;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #37a4cb !important;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #37a4cb !important;
}

.sign-up-link {
  color: #000;
  font-weight: bold !important;
}
.head {
  color: black;
  font-weight: 700;
}
.forgot {
  float: right;
  font-weight: 600;
  cursor: pointer;
}

.btn {
  margin-top: 30px;
  border-radius: 5px;
}
.btn-dark {
  background: #000;
  border-color: #000;
}
@font-face {
    font-family:Gilroy ;
    src: url("/fonts/Gilroy-Light.otf");
     
}

*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body{
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    height: 100vh;
}

ul{
    margin: 0;
    padding: 0;
    list-style: none;
}

a{
    text-decoration: none;
}



.page-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    display:flow-root;
    height: 100%;
}


.page-wrapper > div {
    width: 50%;
    padding: 0 50px;
    height: auto;
    float:left;
    min-height: 100vh
}


.right {
    background: linear-gradient(193.56deg, #4A6CA8 5.24%, #193058 71.78%);
    color: #fff;
    padding-bottom: 40px !important;
    padding-top: 50px !important;
    padding-left: 100px !important;
}


.right .title h2 {
    color: #F7FAFC;
    font-style: normal;
    font-weight: bold;
    font-size: 56px;
    line-height: 65px;
}

.right .icon1 {
    margin-bottom: 20px;
}

.right .list {
    margin-top: 42px;
}


.right .list > img {
    padding-right: 80px;
}

.right .list ul li {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: -0.005em;
}

.right .list ul li img {
    margin-right: 10px;
}

.right .icon2 {
    margin-top: 35px;
}

.right .icon2 img {
    width: 30px;
    position: relative;
    left: -50px;
}

.right footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 50px;
}

.right footer ul {
    display: flex;
}

.right footer ul li a {
    color: #fff;
}

.right footer ul li:first-child {
    margin-right: 30px;
}

.right .list {
    display: flex;
    align-items: start;
    justify-content: space-between;
}

.right footer p {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 13px;
    display: flex;
    align-items: center;
    color: #A6B7D4;
}

.right footer ul li a {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 13px;
    display: flex;
    align-items: center;
    color: #A6B7D4;
}

.right footer p {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 13px;
    /* or 100% */
    display: flex;
    align-items: center;
    /* Theme/Secondary/Dark */
    color: #A6B7D4;
}
.invalid-feedback-two {
    position: absolute;
    top: 80px;
}
.right footer ul li a {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 13px;
    /* or 100% */
    display: flex;
    align-items: center;
    /* Theme/Secondary/Dark */
    color: #A6B7D4;
}

.left {
    padding: 50px 90px !important;
}

.left .logo {
    margin-bottom: 32px;
}

.left form label {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */
    align-items: center;
    /* Text/Body/Light */
    color: #425466;
    display: inline-block;
    margin-bottom: 5px;
}

.left form input,.left form select {
    width: 100%;
    display: block;
    background: #EDF2F7;
    border-radius: 6px;
    border: 0;
    outline: none;
    color: #7A828A;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 15px;
    height: 55px;
    padding: 0 20px;
}
input::placeholder{
        color: #7A828A !important;
}

.left .input-group {
    margin-bottom: 70px;
}

.left form .two-col {
    display: flex;
    align-items: center;
    justify-content: space-between;
}


.left form .two-col .input-group {
    width: 49%;
}


.left form .condition {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
}

.left form .condition input {
    width: auto;
    height: auto;
    position: relative;
    top: -3px;
    margin-right: 10px;
    background: #BCB3E2;
}

.left form .condition label {
    color: #4E5D78;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 23px;
}

.left .skip a {
    color: #425466;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 162.02%;
}


.left .skip {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.left .skip button {
    background: #193058;
    border-radius: 8px;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 14px;
    color: #FFFFFF;
    width: 93px;
    height: 55px;
    border: 0;
    outline: none;
    cursor: pointer;
    width: 100%;  
}
.right-inner {
    max-width: 540px;
}

.login_switch {
    text-align: center;
    margin-top: 20px;
}

.login_switch span {
    display: inline-block;
    margin-right: 0px;
}

.login_switch a {
    color: #193058;
    font-weight: bold !important;
}
.left .input-group {
    position: relative;
}

.left .input-group a {
    position: absolute;
    right: 16px;
    top: 56%;
    cursor: pointer;
}
.reset_head {
    margin-bottom: 0;
}
@media(max-width:1250px){
    .right .title h2 {
        font-size: 50px;
        line-height: 1.2;
    }
    .right-inner {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .right .list > img {
        padding-right: 0;
    }
    .left {
        padding: 50px 40px !important;
    }
}



@media(max-width:991px){
    .page-wrapper {
        flex-direction: column;
    }
    
    .page-wrapper > div {
        width: 100%;
    }
    .right-inner{
      max-width:100%;
    }
    .list {
    max-width: 540px;
}
}


@media(max-width:767px){
    .left form .two-col .input-group {
        width: 100%;
    }
    
    .left form .two-col {
        flex-direction:column;
    }
    .left {
        margin-bottom: 40px;
    }
    .right {
        padding: 50px 40px !important;
    }
    
    .right .title h2 br {
        display: none;
    }
    
    .right-inner {
        max-width: 100%;
    }
    
    .right .title h2 {
        font-size: 30px;
    }
    
    .right .icon2 img {
        position: static;
        left: 0;
    }
    .left {
        padding: 50px 15px !important;
        height: auto !important;
    }
    .right {
        padding: 50px 15px !important;
        height: auto !important;
    }
    .list {
    max-width: 100%;
}
}


@media(max-width:479px){
    .right footer {
        flex-direction: column;
        align-items: start;
    }
    
    .right footer p {
        margin-bottom: 20px;
    }
    .right footer ul li:first-child {
        margin-right: 15px;
    }
}
</style>
